import React from 'react';
import { PageContent } from '@core/ui';
import { TableProvider } from '@core/table';

import { CashRegistersTableContext } from '../contexts';
import { useCashRegistersTableContext } from '../hooks';
import { CashRegistersTable, CashRegistersTableActionBar } from '../containers';

export const CashRegistersPage = () => {
  const { onFetch } = useCashRegistersTableContext();

  return (
    <TableProvider name='cashRegisters' context={CashRegistersTableContext} onFetch={onFetch}>
      <PageContent $contain={true}>
        <CashRegistersTableActionBar />
        <CashRegistersTable />
      </PageContent>
    </TableProvider>
  );
};
